import { setProps } from '../props'

export default (props) => () => {

  setProps(props)
  
}
